import * as sentry from '@sentry/nextjs';

import { Article, Franchises, RichText } from '../../types/Franchises';
import { GlossaryTerm } from '../../types/Glossary';
import { linkGlossaryTermsForRichText } from '../glossary';
import { readingTimeCalculator } from '../readingTimeCalculator';

// can be extended to use other props from the article
export const getRichTextContent = (article: Article) => {
  return (article || [])
    .map((art) => {
      if (art.component === 'richText') {
        return (art as RichText)?.richText?.content;
      }
      return null;
    })
    .flat()
    .map((node) => node?.content)
    .flat();
};

export const getWordCount = (article: Article) => {
  return getRichTextContent(article).reduce(
    (prev, curr) => prev + (curr?.text?.split(' ')?.length || 0),
    0,
  );
};

export const getAnalyticsMap = (
  locale: string,
  franchise: string,
  pageData: Franchises,
) => {
  const wordCount = getWordCount(pageData.content.article);

  return {
    locale,
    'article author': pageData.content.author,
    'article franchise': franchise,
    'article media type':
      pageData.content.heroPicker?.[0]?.component?.toLowerCase(),
    'article reading time': readingTimeCalculator(wordCount),
    'article slug': pageData.slug,
    'article tag': pageData.content.tag,
    'article title': pageData.content.title,
    'article word count': wordCount,
  };
};

export const parseFranchiseContent = (
  franchise: Franchises,
  glossary: GlossaryTerm[],
) => {
  const matchesMap = {};

  return {
    ...franchise,
    content: {
      ...franchise.content,
      article: franchise.content.article.map((blok) => {
        if (blok.component === 'richText') {
          try {
            return {
              ...blok,
              richText: linkGlossaryTermsForRichText(
                glossary,
                (blok as RichText).richText,
                matchesMap,
              ),
            };
          } catch (err) {
            sentry.captureException(err);
            return blok;
          }
        }
        return blok;
      }),
    },
  };
};
